import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { SendOtp, OtpVerify, ChangePassword } from '../../../../api/Auth';
import Recruiter_Common_Profile from '../recruiter_common_profile/Recruiter_Common_Profile';
import Recruiter_Header from '../recruiter_header/Recruiter_Header';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const Recuriter_Reset_Password = () => {
  const navigate = useNavigate();
  const email = localStorage.getItem("user_Email");
  const [otp, setOtp] = useState('');
  const [old_password, setOld_Password] = useState('');
  const [password, setPassword] = useState('');
  const [confpassword, setConfPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false)
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  // <---------- Forgot Password Modals --------->
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  // <---------- OTP Verification Modals --------->
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // <----------- Check the password validation's ---------------->
  const [isValidPassword, setIsValidPassword] = useState(true);

  const token = localStorage.getItem("User_Token");
  const headers = {
    "Authorization": `Bearer ${token}`
  }

  const Send_Otp_Forgot_Password = async () => {
    const data = {
      type: "resetpassword",
      email: email,
    }
    const response = await SendOtp(data)
    if (response.data.statusCode == "200") {
      handleShow();
    }
  }
  // <--------- OTP Verify ------------------->
  const OtpVerifyStuSignUp = async () => {
    try {
      const SendOtpVerifyData = {
        type: "resetpassword",
        email: email,
        otp
      }
      const response = await OtpVerify(SendOtpVerifyData);
      if (response.data.data.isOtpMatch == true) {
        localStorage.removeItem("Student_Register_Email")
        handleShow1();
        handleClose();
        setOtp("")
      }
      else if(response?.data?.statusCode == "400"){
        toast.error(response?.data?.msg);
        setTimeout(()=>{
          handleClose();
          setOtp("")
        })
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  // <--------- Apply The regex for the vaild Password section's ------------->
  const ValidatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{11,}$/;
    setIsValidPassword(regex.test(password));
  };


  // <---------- Onchange events on the password section's ---------------->
  const handlePasswordChange = (event) => {
    const { value } = event.target;
    setPassword(value);
    ValidatePassword(value);
  };

  // <----------- Change Password section's ---------------->
  const Change_Password = async () => {
    const data = {
      old_password,
      password: password
    };

    if (!password) {
      toast.error("please fill the password to processed !!!")
      return;
    }
    if (!confpassword) {
      toast.error("please fill the confirm password to processed !!!")
      return;
    }
    if (password !== confpassword) {
      toast.error("Password do not match !!!")
      return;
    }
    try {
      const response = await ChangePassword(data, headers);
      if (response?.data?.statusCode == "200") {
        toast.success("Password Change Successfully !!!")
        handleClose1();
        setTimeout(()=>{
          navigate("/Signin")
        },1000)
      }
      else if (response?.data?.statusCode == "400") {
        toast.error(response?.data?.msg)
        console.log("Change_Password", response)
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <div class="stepbg">
      {/* <--------- This is Recuriter header section's -------------> */}
      <Recruiter_Header />
      <div class="client_filter-job py-5">
        <div class="stepsForm">
          <form method="post" id="msform">
            <div class="container">
            <ToastContainer style={{ marginTop: "100px" }} />
              <div class="row">
                <div class="col-md-4">
                  {/* <--------- This is Recuriter Common Profile section's -------------> */}
                  <Recruiter_Common_Profile />
                </div>

                {/* <----------- Forgot Password sections --------------> */}
                <Modal show={show1} onHide={handleClose1}>
                <Modal.Header class="modal-header">
                          <h1 class="modal-title fs-5" id="exampleModalLabel">Change Password</h1>
                          <button type="button" onClick={handleClose1} class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                        </Modal.Header>
                  <div class="col-md-12 d-flex">
              
                    <div class="flexdr position-relative p-3 p-md-4 shadow-lg">
                      <div class="sf-steps-form personal_user_info">
                        <div class="row">
                          <div class="col-lg-12 mt-3">
                            <label>New Password</label>
                            <div class="form-floating form-group">
                              <input type={showConfirmPassword ? "text" : "password"} name='password' value={password}
                                onChange={handlePasswordChange}
                                class="form-control"
                                placeholder="New Password" />
                              <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                class="password-toggle eye">
                                {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                              </span>
                            </div>
                          </div>

                          <div class="col-lg-12 mt-3">
                            <label>Confirm New Password</label>
                            <div class="form-floating form-group">
                              <input type={showConfirmNewPassword ? "text" : "password"} name='confpassword' value={confpassword}
                                onChange={(e) => setConfPassword(e.target.value)}
                                class="form-control"
                                placeholder="Confirm New Password" />
                              <span onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                                class="password-toggle eye">
                                {showConfirmNewPassword ? <FaEye /> : <FaEyeSlash />}
                              </span>
                            </div>
                          </div>
                          {!isValidPassword && (
                            <p style={{ color: "red" }}>
                              Password must be at least 11 characters long,
                              contain at least one lowercase letter, one
                              uppercase letter, one digit, and one special
                              character (@$!%*?&).
                            </p>
                          )}
                          <div class="col-lg-12 col-md-12 mt-3">
                            <button type="button" onClick={() => Change_Password()}
                              class="default-btn rounded">
                              Change Password
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>




                <div class='modal fade' id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered">

                    {/* <-------------  OTP Verification sections (Modal)------------> */}
                    <Modal show={show} onHide={handleClose}>
                      <div class="modal-content">

                        <Modal.Header class="modal-header">
                          <h1 class="modal-title fs-5" id="exampleModalLabel">OTP VERIFICATION</h1>
                          <button type="button" onClick={handleClose} class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                        </Modal.Header>
                        <Modal.Body class="modal-body">
                          <div class="title">
                            <h6 class="info">An otp has been sent to <a href="#">{email}</a></h6>
                            <p class="mb-3">Please enter OTP to verify</p>
                          </div>
                          <div class="form-floating form-group">
                            <div class="otp-input-fields">
                              <OtpInput class="otp__digit otp__field__1"
                                value={otp}
                                onChange={(newOtp) => { setOtp(newOtp) }}
                                numInputs={6}

                                renderInput={(props) =>
                                  <input   {...props} />}
                              />
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer class="modal-footer">
                          <a type="button" onClick={OtpVerifyStuSignUp} data-bs-target="#exampleModalToggle2"
                            data-bs-toggle="modal" class="default-btn py-2 rounded w-100">Verify</a>
                        </Modal.Footer>
                      </div>
                    </Modal>

                  </div>
                </div>

                <div class="col-md-8 d-flex">
                  <div class="flexdr position-relative p-3 p-md-4 shadow-lg">
                    <div class="sf-steps-form personal_user_info">
                      <h4>Reset Password</h4>
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <div class="form-groups emailforgot">
                            <label>Email address</label>
                            <input type="email" placeholder="freshgrad@gmail.com"
                              value={email} disabled />
                          </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                          <a type="button" onClick={() => { Send_Otp_Forgot_Password() }}
                            class="default-btn py-2 rounded" data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-whatever="@mdo">
                            Send OTP
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Recuriter_Reset_Password